import React from 'react';

import { useFulfillmentPlannerContext } from '../context';

import PickupTime from './index';

const FulfillmentPlannerContextPickupTimeContainer = () => {
  const { estimatedPickup } = useFulfillmentPlannerContext();

  return <PickupTime emptyValue='--' pickupDateTime={estimatedPickup} />;
};

export default FulfillmentPlannerContextPickupTimeContainer;
